<div *ngIf="show">
    
    <div  class="overlay">
        <div class="close-button" (click)="close()">✕</div>
        <img [src]="imageUrl" alt="Preview" class="full-image" />
    </div>  
</div>